import { render, staticRenderFns } from "./HullAndMachineryTab.vue?vue&type=template&id=c0ff86b6&"
import script from "./HullAndMachineryTab.vue?vue&type=script&lang=js&"
export * from "./HullAndMachineryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports